import { useEffect, useMemo } from "react";
import { useGetPlayerHeadshotsQuery } from "../store/api/mlbApi";
import { useGetNbaPlayerHeadshotsQuery } from "../store/api/nbaApi";
import { useGetNflPlayerHeadshotsQuery } from "../store/api/nflApi";
import {
  collectHeadshotUrls,
  preloadHeadshotUrls,
} from "../utils/playerHeadshots";

const EMPTY_HEADSHOTS = {};

export const usePlayerHeadshots = (playerIds = [], options = {}) => {
  const { sport = "mlb" } = options;

  const ids = useMemo(
    () => [...new Set(playerIds.filter(Boolean).map(String))].sort(),
    [playerIds]
  );

  const mlbQuery = useGetPlayerHeadshotsQuery(ids, {
    skip: ids.length === 0 || sport !== "mlb",
  });

  const nbaQuery = useGetNbaPlayerHeadshotsQuery(ids, {
    skip: ids.length === 0 || sport !== "nba",
  });

  const nflQuery = useGetNflPlayerHeadshotsQuery(ids, {
    skip: ids.length === 0 || sport !== "nfl",
  });

  const { data, isLoading } =
    sport === "nba" ? nbaQuery : sport === "nfl" ? nflQuery : mlbQuery;
  const headshots = data || EMPTY_HEADSHOTS;

  useEffect(() => {
    preloadHeadshotUrls(collectHeadshotUrls(headshots));
  }, [headshots]);

  return { headshots, isLoading };
};
